import { formatQuery, RuleGroupType } from 'react-querybuilder'

import { create } from 'zustand'

export type QueryState = {
  [key: string]: {
    query: RuleGroupType
    jsonataExpression: string
  }
}

interface QueryBuilderStore {
  stepId: string
  inputId: string
  setIds: (stepId: string, inputId: string) => void
  queryConfig: QueryState
  updateQuery: (query: RuleGroupType) => void
  resetQuery: (stepId: string, inputId: string) => void
  showOverlay: boolean
  setShowOverlay: (showOverlay: boolean) => void
}

export const useQueryBuilderStore = create<QueryBuilderStore>((set, get) => ({
  stepId: '',
  inputId: '',
  setIds: (stepId: string, inputId: string) => {
    set(() => ({
      stepId,
      inputId,
    }))
  },
  queryConfig: {},
  updateQuery: (query: RuleGroupType) => {
    const { stepId, inputId } = get()
    const jsonataExpression = formatQuery(query, { format: 'jsonata', parseNumbers: true })

    set((state) => ({
      queryConfig: {
        ...state.queryConfig,
        [`${stepId}-${inputId}`]: { query, jsonataExpression },
      },
    }))
  },
  resetQuery: (stepId: string, inputId: string) => {
    set((state) => ({
      queryConfig: {
        ...state.queryConfig,
        [`${stepId}-${inputId}`]: { query: { combinator: 'and', rules: [] }, jsonataExpression: '' },
      },
    }))
  },
  showOverlay: false,
  setShowOverlay: (showOverlay: boolean) => {
    set(() => ({
      showOverlay,
    }))
  },
}))
